import { useState } from "react";

// The "מחיקת תמונה" confirmation: clicking an attached image asks before removing it from the form
export const useDeleteImageConfirm = (setFormData) => {
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    imageIndex: null,
  });

  const handleImageClick = (index) => {
    setDeleteConfirm({
      open: true,
      imageIndex: index,
    });
  };

  const handleDeleteConfirm = () => {
    if (deleteConfirm.imageIndex !== null) {
      setFormData((prev) => ({
        ...prev,
        images: prev.images.filter(
          (_, index) => index !== deleteConfirm.imageIndex
        ),
      }));
    }
    setDeleteConfirm({
      open: false,
      imageIndex: null,
    });
  };

  const handleDeleteCancel = () => {
    setDeleteConfirm({
      open: false,
      imageIndex: null,
    });
  };

  return { deleteConfirm, handleImageClick, handleDeleteConfirm, handleDeleteCancel };
};
